import React from 'react';
import { View, Flex, Text, ProgressBar } from '@smarterservices/smarter-ui';

// Card container
const Card = (props) => {
  return (
    <View
      as="div"
      display="block"
      padding="none"
      margin="none"
      background="primary"
      borderWidth="small"
      borderColor="primary"
      boxShadow="small"
      borderRadius="medium"
      focusPosition="inset"
      withFocusOutline={false}
      position="relative"
      width="100%"
      height="100%"
      {...props}
    >
      {props.children}
    </View>
  );
};

// Card.Header wraps Title and Actions in a Flex layout
Card.Header = function CardHeader({ children, background, ...props }) {
  return (
    <View
      as="div"
      withVisualDebug={false}
      background={background || 'primary'}
      borderRadius="medium medium none none"
      padding="xx-small"
      {...props}
    >
      <Flex justifyItems="space-between" height="30px" margin="none">
        {children}
      </Flex>
    </View>
  );
};

// Card.Title component
Card.Title = function CardTitle(props) {
  return (
    <Flex.Item>
      <Text {...props}>{props.children}</Text>
    </Flex.Item>
  );
};

// Card.Actions component
Card.Actions = function CardActions(props) {
  return <Flex.Item>{props.children}</Flex.Item>;
};

Card.Progress = function Progress(props) {
  return (
    <ProgressBar
      size="x-small"
      screenReaderLabel="Loading completion"
      valueNow={40}
      valueMax={60}
      margin="0 0"
      {...props}
    />
  );
};

// Card.Body component
Card.Body = function CardBody(props) {
  return (
    <View
      as="div"
      id="FocusModeContainer"
      maxWidth="100%"
      minWidth="100%"
      height="calc(100% - 44px)"
      textAlign="center"
      margin="none"
      padding="xx-small"
      overflowX="hidden"
      overflowY="hidden"
      withVisualDebug={false}
    >
      {props.children}
    </View>
  );
};

export default Card;
